<!-- eslint-disable prettier/prettier -->
<ng-container *transloco="let t">
  <section
    *ngIf="address || phoneNumber"
    class="address-details-overview"
    [class.popsy-card]="hideEdit"
    [class.sm]="(lessThan$ | async)?.sm">
    <div class="header" [class.row]="!hideEdit">
      <ng-container *ngIf="hideEdit">
        <h3>{{ t('title_delivery_information') }}</h3>
        <span class="fixed-space-16" aria-hidden="true"></span>
        <span class="line" aria-hidden="true"></span>
        <span class="fixed-space-16" aria-hidden="true"></span>
      </ng-container>

      <ng-container *ngIf="!hideEdit">
        <h3 class="title">{{ t('title_delivery_information') }}</h3>
        <span class="fixed-space-8" aria-hidden="true"></span>

        <button
          *ngIf="!hideEdit"
          tabindex="-1"
          class="button icon-button popsy-button-option"
          (click)="onEditButtonClick()">
          <popsy-icon-pencil-write-2 class="icon gray-01"></popsy-icon-pencil-write-2>
        </button>
      </ng-container>
    </div>

    <span class="fixed-space-8" aria-hidden="true"></span>

    <ng-container *ngIf="deliveryId">
      <div class="row name">
        <p class="text">{{ deliveryId }}</p>
      </div>
      <span class="fixed-space-4" aria-hidden="true"></span>
    </ng-container>

    <ng-container *ngIf="fullName">
      <div class="row name">
        <ng-container *ngIf="!(lessThan$ | async)?.mobileXL">
          <p class="label">{{ t('label_name') }}:</p>
          <span class="fixed-space-8" aria-hidden="true"></span>
        </ng-container>
        <p class="text">{{ fullName }}</p>
      </div>
      <span class="fixed-space-4" aria-hidden="true"></span>
    </ng-container>

    <ng-container *ngIf="address">
      <div class="row address">
        <ng-container *ngIf="!(lessThan$ | async)?.mobileXL">
          <p class="label">{{ t('label_address') }}:</p>
          <span class="fixed-space-8" aria-hidden="true"></span>
        </ng-container>
        <p class="text">
          {{ address.address }} {{ address.addressDetails }} {{ address.city }} {{
          address.province }} {{ address.postalCode }} {{ address.country }}
        </p>
      </div>
      <span class="fixed-space-4" aria-hidden="true"></span>
    </ng-container>

    <div class="row email" *ngIf="email">
      <ng-container *ngIf="!(lessThan$ | async)?.mobileXL">
        <p class="label">{{ t('hint_email') }}:</p>
        <span class="fixed-space-8" aria-hidden="true"></span>
      </ng-container>
      <p class="text">{{ email }}</p>
      <span class="fixed-space-4" aria-hidden="true"></span>
    </div>
    <span class="fixed-space-4" aria-hidden="true"></span>

    <div class="row" [class.arabic-phone]="language === 'ar'" *ngIf="phoneNumber">
      <ng-container *ngIf="!(lessThan$ | async)?.mobileXL">
        <p class="label">{{ t('label_phone') }}:</p>
        <span class="fixed-space-8" aria-hidden="true"></span>
      </ng-container>
      <p class="text">{{ phoneNumber?.display }}</p>
    </div>
    <div class="row" [class.arabic-phone]="language === 'ar'" *ngIf="contactDetails">
      <ng-container *ngIf="!(lessThan$ | async)?.mobileXL">
        <p class="label">{{ t('label_phone') }}:</p>
        <span class="fixed-space-8" aria-hidden="true"></span>
      </ng-container>
      <p class="text">
        +{{ contactDetails.phone_country_code }} {{ contactDetails.phone_number }}
      </p>
    </div>
    <span class="fixed-space-24" aria-hidden="true"></span>
  </section>

  <section *ngIf="!(address || phoneNumber)" class="address-details-overview">
    <div class="row">
      <p>{{ t('message_add_delivery_info') }}</p>
    </div>
    <div class="row">
      <button
        *ngIf="!hideEdit"
        class="button popsy-button-primary"
        [attr.aria-label]="t('action_add_delivery_info')"
        (click)="onEditButtonClick()">
        {{ t('action_add_delivery_info') }}
      </button>
    </div>
  </section>
</ng-container>
